import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=4451e03b&scoped=true"
import script from "./anchor.vue?vue&type=script&lang=js"
export * from "./anchor.vue?vue&type=script&lang=js"
import style0 from "./anchor.vue?vue&type=style&index=0&id=4451e03b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4451e03b",
  null
  
)

export default component.exports